<div class="game-clicker-container">
  <div class="svgContainer" [inlineSVG]="svgSource" (onSVGInserted)="init($event)"></div>

  <div *ngFor="let broedel of gameData" class="extraClicker" [id]="'extraClicker' + broedel.nr"
      (click)="clickExtra($event, broedel)"
      [ngStyle]="broedel.extraStyle"></div>

  <div class="clockcontainer">
    <app-game-clicker-clock [position]="state.position"></app-game-clicker-clock>
  </div>
  <div class="tellerContainer">
    <app-game-teller>{{state.count}}</app-game-teller>
  </div>
  <div *ngFor="let broedel of gameData" class="broedelHit" [ngClass]="{explode: broedel.done}"
    [ngStyle]="broedel.style">

  </div>
  <div class="editor" [ngClass]="{display: showEditor}" [ngStyle]="debugStyle">
    <div *ngFor="let broedelPos of levelInfo">
      <div>
        {{broedelPos.number}}
        <input [(ngModel)]="broedelPos.enable" type="checkbox" [value]="true" (change)="updateLevelInfo()">
        <input [(ngModel)]="broedelPos.dx" type="number" [step]="0.1" (change)="updateLevelInfo()">
        <input [(ngModel)]="broedelPos.dy" type="number" [step]="0.1" (change)="updateLevelInfo()">
      </div>
    </div>
    <div class="buttons">
      <button (click)="move()">move</button>
    </div>
  </div>
</div>
